import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WhatsappGroupStateInterface } from '../../domain/interfaces';
import { ManageWhatsappGroupResponseInterface, ResponseWhatsappGroupInterface } from '../../domain/interfaces/WhatsappGroupInterface';

const initialState: WhatsappGroupStateInterface = {
    whatsappGroups: [],
    whatsappGroupForm: {
        id: '',
        name: '',
        link: '',
        status: true,
    },
    loading: false,
    error: null,
    pagination: {
        totalResults: 0,
        totalPages: 0,
        currentPage: 1,
    },
    paginationRequest: {
        pagination: 10,
        lastVisibleId: null,
        pageCursors: { 1: null },
    },
};

const ManageWhatsappGroupSlice = createSlice({
    name: 'manageWhatsappGroups',
    initialState,
    reducers: {
        fetchWhatsappGroupsStartReducer(state) {
            state.loading = true;
            state.error = null;
        },
        fetchWhatsappGroupSuccessReducer(state, action: PayloadAction<ResponseWhatsappGroupInterface>) {
            state.loading = false;
            state.whatsappGroups = action.payload.whatsappGroupData
            state.pagination.totalResults = action.payload.totalGroups;
            state.pagination.totalPages = action.payload.totalPages
            
            const nextPage = state.pagination.currentPage + 1;
            const lastVisibleId = action.payload.whatsappGroupData.at(-1)?.id ?? null;
            state.paginationRequest.pageCursors[nextPage] = lastVisibleId;
            
            state.paginationRequest.lastVisibleId = lastVisibleId;
        },
        setCurrentPageReducer: (state, action: PayloadAction<number>) => {
            state.pagination.currentPage = action.payload
        },
        fetchWhatsappGroupsFailureReducer(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
        clearWhatsappGroupsErrorReducer(state) {
            state.error = null;
        },
        setWhatsappGroupFormReducer(state, action: PayloadAction<WhatsappGroupStateInterface['whatsappGroupForm']>) {
            state.whatsappGroupForm = action.payload
        },
        fetchAddWhatsappGroupStartReducer(state) {
            state.loading = true;
            state.error = null;
        },
        fetchAddWhatsappGroupSuccessReducer(state, action: PayloadAction<ManageWhatsappGroupResponseInterface>) {
            state.loading = false;
            state.whatsappGroups = [...state.whatsappGroups, action.payload.group]
        },
        fetchAddWhatsappGroupFailureReducer(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
        fetchUpdateWhatsappGroupStartReducer(state) {
            state.loading = true;
            state.error = null;
        },
        fetchUpdateWhatsappGroupSuccessReducer(state, action: PayloadAction<ManageWhatsappGroupResponseInterface>) {
            state.loading = false;
            state.whatsappGroups = state.whatsappGroups.map((whatsappGroup) => {
                if (whatsappGroup.id === action.payload.group?.id) {
                    return action.payload.group;
                }
                return whatsappGroup;
            })
        },
        fetchUpdateWhatsappGroupFailureReducer(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    fetchWhatsappGroupsStartReducer,
    fetchWhatsappGroupsFailureReducer,
    clearWhatsappGroupsErrorReducer,
    setCurrentPageReducer,
    fetchWhatsappGroupSuccessReducer,
    setWhatsappGroupFormReducer,
    fetchAddWhatsappGroupStartReducer,
    fetchAddWhatsappGroupSuccessReducer,
    fetchAddWhatsappGroupFailureReducer,
    fetchUpdateWhatsappGroupStartReducer,
    fetchUpdateWhatsappGroupSuccessReducer,
    fetchUpdateWhatsappGroupFailureReducer
} = ManageWhatsappGroupSlice.actions;

export default ManageWhatsappGroupSlice.reducer;
